import { LANGUAGE_METADATA, BUSINESS_TYPE_METADATA, PARTNER_METADATA } from '../social/constants';
const userMatchesCommunityCategorySegment = (userFilters, categoryOrCommunity) => {
    var _a, _b, _c, _d, _e, _f;
    return (((_a = categoryOrCommunity.metadata) === null || _a === void 0 ? void 0 : _a[LANGUAGE_METADATA])
        ? userFilters[LANGUAGE_METADATA].includes((_b = categoryOrCommunity.metadata) === null || _b === void 0 ? void 0 : _b[LANGUAGE_METADATA])
        : true) &&
        (((_c = categoryOrCommunity.metadata) === null || _c === void 0 ? void 0 : _c[BUSINESS_TYPE_METADATA])
            ? userFilters[BUSINESS_TYPE_METADATA] === ((_d = categoryOrCommunity.metadata) === null || _d === void 0 ? void 0 : _d[BUSINESS_TYPE_METADATA])
            : true) &&
        (((_e = categoryOrCommunity.metadata) === null || _e === void 0 ? void 0 : _e[PARTNER_METADATA])
            ? userFilters[PARTNER_METADATA] === ((_f = categoryOrCommunity.metadata) === null || _f === void 0 ? void 0 : _f[PARTNER_METADATA])
            : true);
};
export default userMatchesCommunityCategorySegment;
//# sourceMappingURL=userMatchesCommunityCategorySegment.js.map